module.exports = __webpack_public_path__ + "img/home_main_image.f32230e9.png";